const isEditMode = document.querySelector("body").classList.contains("mgnl-admin");
export default isEditMode;
